<div (click)="select()" (mouseover)="onMouseOver()" (mouseleave)="onMouseOut()"
     style="position: relative;" [attr.data-cy]="'menu-item-' + model?.label"
     [ngClass]="{'tdo-subnav-item-selected': isSelected, 'tdo-subnav-item-deselected': !isSelected && !isHovered, 'tdo-subnav-item-hovered': isHovered}" data-cy="tdo-subnav-item">
  <ng-content></ng-content>
  <div (mouseout)="isShowMenu = false;" class="tdo-dropdown-menu" data-cy="tdo-subnav-item-dropdown-menu">
    <div class="tdo-dropdown-menu-content" style="top: 12px; right: unset; left: -53px; width: 110px; border: 2px solid var(--tdo-primary-accent);" [ngClass]="{'tdo-dropdown-menu-show': isShowMenu}" data-cy="tdo-subnav-item-dropdown-content">
      <div (click)="onMenuItemClick(child)" *ngFor="let child of model?.children" class="tdo-dropdown-menu-item" data-cy="tdo-subnav-item-dropdown-item-{{child.label}}">{{child.label}}</div>
    </div>
  </div>
</div>
